<template>
  <ContentPage back>
    <template #header>
      <ContentPageTitle>Your Reward</ContentPageTitle>
    </template>
  
    <Section>
      <div class="d-flex flex-column align-center black--text">
        <EnableBar :redemption="currentReward" />

        <div class="text-center mt-3" style="font-size: 16px;">
          Your {{ currentReward.reward_name }} is here!
        </div>

        <img class="mt-2" :src="currentBrand.image_url" width="225px"/>

        <div class="mt-1 font-weight-bold" style="font-size: 20px;">{{ $formatters.formatCurrency(currentReward.amount_cents) }}</div>

        <div class="mt-4 pa-4 rounded" style="border: 1px solid grey;">
          <Credential v-for="(cred, i ) in currentReward.credential_list" :key="i" :cred="cred" />
        </div>        

        <div class="text-left font-weight-bold mt-6" style="width: 100%">Issuer Instructions:</div>

        <div class="mt-2" style="font-size: 10px; line-height: 1.25;" v-html="currentReward.redemption_instructions"></div>

        <div v-if="hasRestrictions" style="font-size: 10px" class="grey--text text--darken-1 mt-2">
          The following <OtherTextDialog linkText="disclaimer" :body="currentBrand.disclaimer" />
          and <OtherTextDialog linkText="terms" :body="currentBrand.terms" /> apply. 
        </div>
        <div v-else style="font-size: 10px" class="grey--text text--darken-1 mt-2">
          The following <OtherTextDialog linkText="disclaimer" :body="currentBrand.disclaimer" /> applies.
        </div>

        <div style="font-size: 10px" class="mt-3">
          If you have any problems or questions, please contact Tango customer service
          at <a href="mailto:cs@tangocard.com">cs@tangocard.com</a>.
        </div>
      </div>
    </Section>

    <ErrorOverlay title="Problem Loading Reward" v-model="error_dialog" :loading="loading" >
      {{ error_message }}
    </ErrorOverlay>
  </ContentPage>
</template>

<script>
import { ContentPage, ContentPageTitle, Section } from '@/components/pages'
import Credential from './Credential'
import EnableBar from './EnableBar'
import OtherTextDialog from '../OtherTextDialog'

import ErrorOverlayMixin from '@/lib/mixins/ErrorOverlay'

import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'RewardsRewardView',

  mixins: [ ErrorOverlayMixin ],

  props: ['redemption_id'],

  components: { ContentPage, ContentPageTitle, Credential, EnableBar, OtherTextDialog, Section },

  computed: {
    ...mapGetters('rewards', ['currentBrand', 'currentReward']),

    hasRestrictions() {
      const { disclaimer, terms } = this.currentBrand

      return terms !== '' && disclaimer !== terms
    },
  },

  data: () => ({
    dialogVisible: false,
  }),

  methods: {
    ...mapActions('rewards', ['loadCurrentBrand', 'loadCurrentReward']),
  },

  async created() {
    this.loading = true

    await this.loadCurrentReward( this.redemption_id ),
    await this.loadCurrentBrand( this.currentReward.brand_key )

    this.loading = false
  },
}
</script>
